var exports = {
  "iE": "xa15a2ab7--c27d8a--wrapper",
  "Qq": "xa15a2ab7--c27d8a--text",
  "T9": "xa15a2ab7--c27d8a--max",
  "oY": "xa15a2ab7--c27d8a--input-row",
  "Pf": "xa15a2ab7--c27d8a--label",
};

module.exports = exports;
